export enum NotificationStatus {
  New = 1,
  Read = 2
}
